import { useState } from 'react';

export const useModal = <T = any>() => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [data, setData] = useState<T | undefined>(undefined);

  const openModal = (data?: T) => {
    setIsOpen(true);
    if (data !== undefined) {
      setData(data);
    }
  };

  const closeModal = () => {
    setIsOpen(false);
    setTimeout(() => {
      setData(undefined);
    }, 100);
  };

  return {
    isOpen,
    data,
    openModal,
    closeModal,
  };
};
